import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IdleService implements OnDestroy {
  private readonly IDLE_TIMEOUT_MS = 7_200_000; // 2h
  private timedOut = false;
  private timerSub: Subscription;
  private activitySub: Subscription;

  watch(): void {
    this.resetTimer();

    const activity$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click'),
      fromEvent(document, 'scroll'),
      fromEvent(document, 'touchstart'),
    );

    this.activitySub = activity$.pipe(debounceTime(500)).subscribe(() => {
      if (this.timedOut) {
        location.reload();
      }
      this.resetTimer();
    });
  }

  private resetTimer(): void {
    this.timerSub?.unsubscribe();
    this.timerSub = timer(this.IDLE_TIMEOUT_MS).subscribe(() => {
      this.timedOut = true;
    });
  }

  ngOnDestroy(): void {
    this.timerSub?.unsubscribe();
    this.activitySub?.unsubscribe();
  }
}
